import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Dropdown, DropdownAnchor, DropdownContent, DropdownMenu, MenuItem } from '@fiverr-private/dropdown';
import { IconButton } from '@fiverr-private/button';
import { ElementType } from '@fiverr-private/bianka_js';
import { EllipsisIcon } from '@fiverr-private/visuals';
import { AppI18n } from '../../../i18n/i18n';
import { reportClickedElementBriefOverview } from '../../../monitoring/bqEvents';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';

export interface AdditionalOptionsMenuProps {
  briefId: string;
  briefStatus?: SellerBriefResponse['status'];
  onEdit?: () => void;
  onDuplicate?: () => void;
  onDelete?: () => void;
}

export const AdditionalOptionsMenu: React.FC<AdditionalOptionsMenuProps> = ({
  briefId,
  briefStatus,
  onEdit,
  onDuplicate,
  onDelete,
}) => {
  const handleEdit = () => {
    reportClickedElementBriefOverview({
      briefId,
      elementName: 'edit_brief',
      elementType: ElementType.BUTTON,
      briefStatus,
    });
    onEdit?.();
  };

  const handleDuplicate = () => {
    reportClickedElementBriefOverview({
      briefId,
      elementName: 'duplicate_brief',
      elementType: ElementType.BUTTON,
      briefStatus,
    });
    onDuplicate?.();
  };

  const handleDelete = () => {
    reportClickedElementBriefOverview({
      briefId,
      elementName: 'delete_brief',
      elementType: ElementType.BUTTON,
      briefStatus,
    });
    onDelete?.();
  };

  return (
    <Container flexShrink="0">
      <Dropdown position="bottom-end">
        <DropdownAnchor>
          <IconButton aria-label="Brief Options" size="sm" intent="secondary" variant="ghost">
            <EllipsisIcon />
          </IconButton>
        </DropdownAnchor>
        <DropdownContent appendToBody>
          <DropdownMenu>
            {onEdit && (
              <MenuItem onClick={handleEdit}>
                <AppI18n k="actions_menu.edit" />
              </MenuItem>
            )}
            {onDuplicate && (
              <MenuItem onClick={handleDuplicate}>
                <AppI18n k="actions_menu.duplicate" />
              </MenuItem>
            )}
            {onDelete && (
              <MenuItem onClick={handleDelete}>
                <AppI18n k="actions_menu.delete" />
              </MenuItem>
            )}
          </DropdownMenu>
        </DropdownContent>
      </Dropdown>
    </Container>
  );
};
